import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiclient from "../../apiclient";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { PROJECT_DETAIL } from "../../apiclient/apiEndpoints";
import Dashboard from "../../components/scene/Dashboard";

const { useUnoSelector } = UnoStoreHooks;
const { SimToggleSwitch } = UiComponents;


const ProjectDetails = () => {
  const params = useParams();
  const { uuid } = params;
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const [details, setDetails] = useState({});
  
  const getProjectDetails = async() =>{
    try {
      let data = await apiclient.get(`${configData.config.API_URL}${PROJECT_DETAIL}/${uuid}`);
      setDetails(data)
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(()=>{
     getProjectDetails();
  },[])

  return (
    <>
       <Dashboard scenes={details?.scenes || []} />     
    </>
  )
}

export default ProjectDetails;